export const memberCollectionEn = {
    xunjiadang:'Member collection',
    fuwushoucang:'Service collection',
    zhiliaoshoucang:'Data collection',
    kechengshoucang:'Curriculum collection',
    zangjiashoucang:'Expert collection',
    quanxuan:'All',
    quxiaoshoucang:'Cancel collection',
    fuwuxinxi:'Service information',
    shoucangshijian:'Collection time',
    caozuo:'operation',
    jiage:'Price',
    kechengshijian:'Course information',
    keshi:'Class hour',
    zuanjiajiesao:'Expert introduction',
    zixunchishu:'Frequency of consultation'
}


// WEBPACK FOOTER //
// ./src/lang/member/memberCollection/memberCollectionEn.js